























import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { AlertFeed } from "@/models";
import AlertFeedItem from "./AlertFeedItem.vue";
import AlertFeedMixin from "@/mixins/http/AlertFeed";
import QueryableInterface, {
  QueryableFilterInterface,
} from "@/interfaces/QueryableInterface";
import { RequestData } from "@/store/types/RequestStore";

const requestTag = "alertFeeds";
const DEFAULT_MAX_ITEMS = 10;

export interface AlertFeedFilter {
  type: string;
  alert?: string;
  media?: {
    radio: boolean;
    tv: boolean;
  };
}

@Component({
  components: {
    AlertFeedItem,
  },
})
export default class AlertFeedList extends Mixins(AlertFeedMixin) {
  @Prop() readonly filter?: AlertFeedFilter;
  @Prop({ default: DEFAULT_MAX_ITEMS }) readonly maxItems?: number;
  @Prop({ default: true }) readonly showMore?: boolean;

  @Watch("filter", { deep: true, immediate: true })
  onFilterChange() {
    this.items = [];
    this.load();
  }

  items: AlertFeed[] = [];
  page = 1;

  loading = true;
  loadingNext = false;

  get params(): QueryableInterface {
    const params: QueryableInterface = {
      page: {
        size: this.maxItems || DEFAULT_MAX_ITEMS,
        number: this.page,
      },
    };

    if (this.filter) {
      const filter: QueryableFilterInterface = {};

      if (this.filter.type) {
        filter.type = this.filter.type;
      }

      if (this.filter.alert && this.filter.alert != "all") {
        filter.alert = this.filter.alert;
      }

      if (this.filter.media) {
        if (this.filter.media.radio && !this.filter.media.tv) {
          filter["media"] = 1;
        } else if (!this.filter.media.radio && this.filter.media.tv) {
          filter["media"] = 2;
        }
      }

      params.filter = filter;
    }

    return params;
  }

  get alertFeedRequestStatus(): RequestData {
    return this.requestStatus(requestTag);
  }

  get hasNextPage(): boolean {
    if (this.alertFeedRequestStatus) {
      return this.alertFeedRequestStatus.links?.next != null || false;
    }

    return false;
  }

  async load() {
    this.loading = true;
    const items = await this.getAlertFeeds(this.params, requestTag);
    if (this.page === 1) {
      this.items = [...items];
    } else {
      this.items = [...this.items, ...items];
    }
    this.loading = false;
  }

  async loadNext() {
    if (this.showMore == false) {
      return;
    }

    this.loadingNext = true;
    this.page++;
    await this.load();
    this.loadingNext = false;
  }
}
